var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flsv2",class:[
    {'flsv2-selected': _vm.selected }
],on:{"click":function($event){$event.stopPropagation();return _vm.onStepClick($event)}}},[_vm._v(" "+_vm._s(_vm.step)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }